import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { nothing as w, html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './result-card.scss.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';

const ctaConverter = {
    fromAttribute: (v) => {
        try {
            return v ? JSON.parse(v) : null;
        }
        catch (_a) {
            return null;
        }
    },
    toAttribute: () => null,
};
class ResultCardBlock extends s {
    constructor() {
        super(...arguments);
        this.blockId = '';
        this.items = [];
        this.cta = null;
    }
    get isRTL() {
        return this.rtl || isRTL();
    }
    renderCTA() {
        var _a;
        if (!this.cta)
            return w;
        return $ `<generic-button-updated label="${this.cta.label}" href="${this.cta.href}" target="${(_a = this.cta.target) !== null && _a !== void 0 ? _a : '_self'}" type="primary" color="burgundy" styleType="light"></generic-button-updated>`;
    }
    renderMedia(item) {
        var _a, _b, _c;
        if (item.mediaType === 'image' && item.imageUrl) {
            return $ `<generic-image src="${item.imageUrl}" alt="${(_a = item.imageAlt) !== null && _a !== void 0 ? _a : ''}" loading="lazy"></generic-image>`;
        }
        return $ `<span class="result-card__emoji" role="img" aria-label="${(_b = item.emojiLabel) !== null && _b !== void 0 ? _b : 'Unknown'}">${(_c = item.emoji) !== null && _c !== void 0 ? _c : '❓'}</span>`;
    }
    resolveItem() {
        var _a, _b, _c;
        const params = new URLSearchParams(window.location.search);
        const outcome = (_b = (_a = this.outcome) !== null && _a !== void 0 ? _a : params.get('outcome')) !== null && _b !== void 0 ? _b : '';
        if (outcome === 'no-combination-match') {
            return {
                outcomeKey: 'no-combination-match',
                mediaType: 'emoji',
                emoji: '⚠️',
                emojiLabel: 'Warning',
                text: '<strong>[Optimizely] No combination matched the selected answers.</strong> Review the combinations configured in the Form Selector Result blocks.',
            };
        }
        if (!outcome) {
            return ((_c = this.items.find(i => !i.outcomeKey || i.outcomeKey === '*')) !== null && _c !== void 0 ? _c : {
                outcomeKey: '',
                mediaType: 'emoji',
                emoji: '⚠️',
                emojiLabel: 'Warning',
                text: '<strong>[Optimizely] No default item configured.</strong> Add a Result Card item with an empty outcome key to serve as the default.',
            });
        }
        const matched = this.items.find(i => i.outcomeKey === outcome);
        if (!matched) {
            return {
                outcomeKey: 'outcome-not-configured',
                mediaType: 'emoji',
                emoji: '⚠️',
                emojiLabel: 'Warning',
                text: `<strong>[Optimizely] Outcome key "${outcome}" not found.</strong> Check that the outcome keys in the Form Selector Result blocks match those configured in the Result Card items.`,
            };
        }
        return matched;
    }
    stripHtml(text) {
        var _a, _b;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        return (_b = (_a = doc.body.textContent) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : '';
    }
    render() {
        const item = this.resolveItem();
        return $ `<section class="result-card" dir="${this.isRTL ? 'rtl' : 'ltr'}" aria-label="${this.stripHtml(item.text)}" id="${this.blockId}"><div class="result-card__media">${this.renderMedia(item)}</div><div class="result-card__content"><div class="result-card__text">${o(item.text)}</div>${this.renderCTA()}</div></section>`;
    }
}
ResultCardBlock.styles = css_248z;
__decorate([
    e({ type: Boolean })
], ResultCardBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], ResultCardBlock.prototype, "blockId", void 0);
__decorate([
    e({ type: Array })
], ResultCardBlock.prototype, "items", void 0);
__decorate([
    e({ type: String })
], ResultCardBlock.prototype, "outcome", void 0);
__decorate([
    e({ converter: ctaConverter })
], ResultCardBlock.prototype, "cta", void 0);
customElements.define('result-card', ResultCardBlock);

export { ResultCardBlock };
